import { Image, Heading, Text, useColorModeValue } from '@chakra-ui/react'
import * as React from 'react'
import { RevealFlex } from '..'
import { images } from '../../theme'
import Card, { CardProps } from '../Card'

type EmptyListHandlerProps = CardProps & {
  title?: string
  subTitle?: string
}

const EmptyListHandler: React.FC<EmptyListHandlerProps> = ({ title, subTitle, bg, ...rest }) => {
  const theme = useColorModeValue('white', 'gray.700')
  return (
    <Card
      p={4}
      flex={1}
      width="100%"
      bg={bg ? bg : theme}
      align="center"
      maxWidth="100%"
      justify="center"
      boxShadow="none"
      flexDirection="column"
      shouldAnimate
      border="none"
      {...rest}
    >
      <RevealFlex>
        <Image
          src={images.noData}
          alt="nsoko property empty stat image"
          width="440px"
          maxWidth="100%"
          height="auto"
        />
        <Heading as="h2" textAlign="center" my={3} size="lg" fontWeight="extrabold">
          {title}
        </Heading>
        <Text fontSize="sm" as="h4" textAlign="center">
          {subTitle}
        </Text>
      </RevealFlex>
    </Card>
  )
}

export default EmptyListHandler

EmptyListHandler.defaultProps = {
  title: 'Nothing to see here, yet.',
  subTitle: 'Try again later',
  maxH: '80vh',
  bg: 'transparent'
}
